import { gql } from "@apollo/client";
import { BUSINESS_FAX_FIELDS } from "../queries/businessFax";

export const SEND_BUSINESS_FAX = gql`
  mutation SendBusinessFax($input: SendBusinessFaxInput!) {
    sendBusinessFax(input: $input) {
      ${BUSINESS_FAX_FIELDS}
    }
  }
`;

